import { Link } from "@/lib/router-compat";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

// ---------------------------------------------------------------------------
// CASES — "Funcionando hoy." 3 real featured works + link to all.
// Reuses real client data from trabajos.ts (no invented results).
// ---------------------------------------------------------------------------

const IMG = "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/";

const cases = [
  {
    name: "Arregui Premium",
    desc: "Distribución de carne · CABA y Zona Norte",
    img: IMG + "6a9ec6c0a423db57772d23da.png",
  },
  {
    name: "BJB Repuestos",
    desc: "Taller mecánico y repuestos",
    img: IMG + "6a9ec6c5968770b81c48aa7d.png",
  },
  {
    name: "TreeTecno",
    desc: "Mayorista de tecnología",
    img: IMG + "6a9ec6d14793a2d512ad47a1.png",
  },
];

export function HomeCases() {
  return (
    <section
      data-screen-label="Casos"
      className="mx-auto px-6"
      style={{
        maxWidth: 1240,
        paddingTop: "clamp(80px,10vw,128px)",
        paddingBottom: "clamp(80px,10vw,128px)",
      }}
    >
      <Reveal>
        <div className="flex justify-between items-end gap-6 flex-wrap">
          <div>
            <div
              className="font-mono text-[13px] text-[#A78BFA]"
              style={{ letterSpacing: "0.08em" }}
            >
              09 — TRABAJOS
            </div>
            <h2
              className="mt-5 text-[#EEEDF2] font-medium"
              style={{
                fontSize: "clamp(36px,4.8vw,64px)",
                lineHeight: 1.02,
                letterSpacing: "-0.025em",
              }}
            >
              Funcionando hoy.
            </h2>
          </div>
          <Link
            to="/trabajos"
            className="font-medium text-[#A78BFA] hover:text-[#C4B5FD] transition-colors"
          >
            Ver todos los casos →
          </Link>
        </div>
      </Reveal>

      <div
        className="grid gap-5 mt-12"
        style={{
          gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,340px),1fr))",
        }}
      >
        {cases.map((w, i) => (
          <Reveal key={w.name} delay={i * 0.1}>
            <Link
              to="/trabajos"
              className="border border-[#221F2A] rounded-2xl overflow-hidden bg-[#13111A] hover:border-[#433C52] transition-colors group block"
            >
              <div
                className="overflow-hidden bg-[#1A1722]"
                style={{ aspectRatio: "4 / 3" }}
              >
                <img
                  src={w.img}
                  alt={`${w.name} — ${w.desc}`}
                  loading="lazy"
                  decoding="async"
                  width={600}
                  height={450}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300"
                />
              </div>
              <div className="px-5 py-[18px] flex justify-between gap-3 items-baseline">
                <span className="font-semibold text-[#EEEDF2]">{w.name}</span>
                <span className="text-[13.5px] text-[#9C98A6] text-right">
                  {w.desc}
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-12">
          <Link
            to="/trabajos"
            className="inline-flex items-center gap-2 text-[#A78BFA] font-mono text-[13px] tracking-[0.08em] uppercase hover:text-[#C4B5FD] transition-colors"
          >
            Ver todos los trabajos <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
